import { HttpApi } from './HttpApi';
import type { WorkspaceApi } from './WorkspaceApi';

/**
 * Picks the api without any build flag: if /api/v1/setup/status answers with JSON, the real api
 * is there and HttpApi is used; otherwise the app runs on MockApi and says so in the footer.
 */
export async function detectApi(
  fetchImpl: typeof fetch = (...a) => globalThis.fetch(...a),
): Promise<WorkspaceApi> {
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 1500);
    const res = await fetchImpl('/api/v1/setup/status', {
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    });
    clearTimeout(timer);
    const type = res.headers.get('content-type') ?? '';
    if (res.ok && type.includes('application/json')) {
      const body = (await res.json()) as unknown;
      if (body && typeof body === 'object' && 'needsSetup' in body) return new HttpApi(fetchImpl);
    }
  } catch {
    // no api reachable: fall through to the mock
  }
  // Loaded only when needed, so a deployment with an api never downloads the sample data.
  const { MockApi } = await import('./mock/MockApi');
  return new MockApi();
}
